<template>
  <div class="mask" :class="{ maskActive: isOpenCartDialog }" @click="closeMobileCartDialog" />
  <transition name="slide-up">
    <div
      v-if="isOpenCartDialog"
      id="dialog-market"
      :class="{ active: isOpenCartDialog }"
      class="dialog-bottom"
    >
      <div class="dialog-inner">
        <div class="cart-content">
          <a class="btn-delete" @click.prevent="closeMobileCartDialog">
            <i class="icon-close" />
          </a>
          <div class="item-detail">
            <div class="item-img">
              <NewImage
                v-if="selectedData.Images.length !== 0"
                :url="selectedProductCoverImage.Url"
                :size="'_w752_h956'"
                :name="itemDatas.Name"
              />
            </div>
            <div class="item-info">
              <div class="item-order">
                <a :href="itemDatas.Brand?.Url" class="brand-name">{{ itemDatas.Brand.Name }}</a>
                <div class="item-name">{{ itemDatas.Name }}</div>
                <div class="item-price">
                  <span
                    v-if="itemDatas.SellPrice !== itemDatas.OriginPrice || itemDatas.EventPrice > 0"
                    class="origin-price"
                  >
                    NT$ {{ itemDatas.OriginPrice.toLocaleString() }}
                  </span>
                  <span class="sell-price">
                    NT$
                    {{ mapSellPrice }}
                  </span>
                </div>
                <div v-if="itemDatas.Limit !== 0" class="item-limit">
                  此商品限購 {{ itemDatas.Limit }} 件
                </div>
                <ul class="item-event">
                  <li v-for="event in itemDatas.Events" :key="event.ID">{{ event.Name }}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="item-pick">
            <div class="select-block">
              <div class="select-style" :class="{ spread: sizeBtn }">
                <a class="select-btn" @click.prevent.stop="openSelector">{{ selectedData.Name }}</a>
                <ul class="select-opts" :class="{ isopen: selectIsOpen }">
                  <li
                    v-for="color in itemDatas.Colors"
                    :key="color.ID"
                    @click.prevent="changeImg(color.ID)"
                  >
                    {{ color.Name }}
                  </li>
                </ul>
              </div>
              <Selector
                v-if="!sizeBtn"
                :options="selectedData.Specs"
                :selected="selectedSpec"
                @cb="selectSpec"
              />
            </div>
            <div class="count-selector">
              <Quantity
                :counter="counter"
                :reduce-count="() => reduceCount()"
                :add-count="
                  () =>
                    addCount({
                      maxCount: selectedSpec.Stock,
                      limit: itemDatas.Limit,
                    })
                "
              />
            </div>
            <a
              :class="btnStyleGenerate"
              class="btn btn-primary w-100 btn-add2cart"
              @click.prevent="clickToCart"
            >
              {{ btnDescriptionGenerate }}
            </a>
          </div>
          <div v-if="selectedSpec !== null && selectedSpec.PreOrder" class="product-arrival">
            {{ itemDatas.ArrivalExplanation }}
          </div>
          <div>
            <p
              v-for="(note, noteIndex) in itemDatas.CouponNotes"
              :key="noteIndex"
              class="product-arrival"
            >
              {{ note }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import useShopContentStore from '@global/stores/useShopContentStore';
import NewImage from '@global/components/common/Image/NewImage.vue';
import Selector from '@components/Select.vue';
import Quantity from '@components/Quantity.vue';
import useMsg from '@global/composable/useMessage';
import useAlert from '@global/composable/useAlert';

const { messageBox } = useMsg();
const { alertDialog } = useAlert();

const category = window.ItemCategories[0];

const shopContentStore = useShopContentStore();
const {
  selectedData,
  itemDatas,
  selectedSpec,
  counter,
  selectIsOpen,
  isOpenCartDialog,
  btnStyleGenerate,
  btnDescriptionGenerate,
} = storeToRefs(shopContentStore);

const {
  addCount,
  reduceCount,
  openSelector,
  closeMobileCartDialog,
  addToCart,
  selectSpec,
  changeImg,
} = shopContentStore;

const selectedProductCoverImage = computed(() => {
  return selectedData.value.Images.find((element) => element.Category === 11);
});

const sizeBtn = computed(() => {
  return (
    // 非服飾類 & 單一顏色尺寸 & 尺寸為F，須隱藏尺寸下拉選單
    category !== '服飾' &&
    selectedData.value.Specs?.length === 1 &&
    selectedData.value.Specs[0]?.Name === 'F' &&
    selectedData.value.Specs[0]?.Stock > 0
  );
});

const mapSellPrice = computed(() => {
  return itemDatas.value.EventPrice > 0 && itemDatas.value.EventPrice < itemDatas.value.SellPrice
    ? itemDatas.value.EventPrice
    : itemDatas.value.SellPrice;
});

async function clickToCart() {
  try {
    const resolve = await addToCart();
    if (resolve === undefined) return;
    const { code } = resolve;

    switch (code) {
      case 200:
        messageBox.cart('加入購物車');
        break;
      case 205:
        alertDialog.alert('商品已售完', () => {
          window.location.reload();
        });
        break;
      default:
        break;
    }
  } catch (error) {
    console.log(error);
  }
}
</script>
